/**
 * Lightweight frontend Area model.
 * Mirrors key identifying fields from backend Area/NeighbourhoodArea.
 */
export class Area {
    readonly neighbourhood: string | null
    readonly region: string | null
    readonly country: string | null

    constructor(init: {
        neighbourhood: string | null
        region: string | null
        country: string | null
    }) {
        this.neighbourhood = init.neighbourhood
        this.region = init.region
        this.country = init.country
    }

    static fromDict(d: Record<string, unknown>): Area {
        return new Area({
            neighbourhood: d["n"] != null ? String(d["n"]) : null,
            region: d["r"] != null ? String(d["r"]) : null,
            country: d["c"] != null ? String(d["c"]) : null,
        })
    }

    getDisplayName(): string {
        return this.neighbourhood ?? "this area"
    }
}

export default Area
